import { ChevronDownSmallIcon, SminexEventIcon } from '@shared/assets/icons';
import { CategoryList } from '@entities/category/ui/CategoryList';
import { typography } from '@shared/tokens/typography.stylex';
import { VerticalDrawer } from '@shared/ui/vertical-drawer';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { TicketInfo } from '@shared/hooks/useFetchQrCode';
import { palette } from '@shared/tokens/palette.stylex';
import { Button } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { useState } from 'react';

interface LeadCollectorMobileTicketProps {
  ticketInfo: TicketInfo;
  qr: string;
}

export const LeadCollectorMobileTicket = ({ ticketInfo, qr }: LeadCollectorMobileTicketProps) => {
  const { eventName, categories, additionalGuests, firstName, lastName } = ticketInfo;
  const { adultCounter, adultGuests, adultGuestsLabel, childCounter, childGuests, childGuestLabel } = additionalGuests;
  const countAdditionalGuests = adultCounter + childCounter;
  const isHasAdditionalGuests = !!countAdditionalGuests;
  const [isQrOpen, setIsQrOpen] = useState(false);
  const [isGuestsOpen, setIsGuestsOpen] = useState(false);
  const svg = qr.replace('height="320"', 'height="320" viewBox="0 0 320 320"');

  return (
    <div {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.logo)}>
        <SminexEventIcon
          colorPrimary={palette['grey-950']}
          colorSecondary={palette['bronze-500']}
          height={16}
          width={121}
        />
      </div>

      <div {...stylex.props(styles.main)}>
        <div {...stylex.props(styles.eventInfo)}>
          <span {...stylex.props(styles.label)}>
            {isHasAdditionalGuests ? `Групповой билет на ${countAdditionalGuests + 1} человек` : 'Персональный билет'}
          </span>

          <span {...stylex.props(styles.eventName)}>{eventName}</span>

          <div {...stylex.props(styles.categories)}>
            <CategoryList categories={categories} />
          </div>
        </div>

        <div {...stylex.props(styles.qrCode)}>
          <UnstyledButton onClick={() => setIsQrOpen(true)}>
            <div dangerouslySetInnerHTML={{ __html: svg }} />
          </UnstyledButton>
          <span {...stylex.props(styles.qrDescription)}>Предъявите QR для прохода на мероприятие</span>
        </div>

        {isHasAdditionalGuests ? (
          <Button
            onClick={() => setIsGuestsOpen(true)}
            variant="primary"
            size="medium"
            settings={{ height: '40px', width: '180px', fontSize: typography['fontSizeBody-5'] }}
          >
            <div {...stylex.props(styles.allGuestsButton)}>
              Все гости
              <ChevronDownSmallIcon color={palette['greyWhite']} width="16" height="16" />
            </div>
          </Button>
        ) : (
          <div {...stylex.props(styles.mainGuest, styles.mainGuestAlone)}>
            <span>
              {firstName} {lastName}
            </span>

            <span {...stylex.props(styles.label)}>Основной гость</span>
          </div>
        )}

        <VerticalDrawer isOpen={isQrOpen} onClose={() => setIsQrOpen(false)} height="324px" swipeThreshold={150}>
          <div {...stylex.props(styles.qrCode, styles.qrCodeDrawer)}>
            <div dangerouslySetInnerHTML={{ __html: svg }} />
            <span {...stylex.props(styles.qrDescription)}>Предъявите QR для прохода на мероприятие</span>
          </div>
        </VerticalDrawer>

        <VerticalDrawer isOpen={isGuestsOpen} onClose={() => setIsGuestsOpen(false)} height="auto" swipeThreshold={150}>
          <div {...stylex.props(styles.guests)}>
            <div {...stylex.props(styles.mainGuest)}>
              <span {...stylex.props(styles.label)}>Основной гость</span>

              <span>
                {firstName} {lastName}
              </span>
            </div>

            {!!adultCounter && (
              <>
                <div {...stylex.props(styles.divider)} />

                <div {...stylex.props(styles.additionalGuests)}>
                  <span {...stylex.props(styles.label)}>{adultGuestsLabel || 'Взрослые гости'}</span>

                  <div {...stylex.props(styles.guestsList)}>
                    {adultGuests.map(({ firstName, lastName, surname }, index) => (
                      <span key={`${firstName}-${lastName}-${surname}-${index}`}>
                        {lastName} {firstName} {surname}
                      </span>
                    ))}
                  </div>
                </div>
              </>
            )}

            {!!childCounter && (
              <>
                <div {...stylex.props(styles.divider)} />

                <div {...stylex.props(styles.additionalGuests)}>
                  <span {...stylex.props(styles.label)}>{childGuestLabel || 'Маленькие гости'}</span>

                  <div {...stylex.props(styles.guestsList)}>
                    {childGuests.map(({ firstName, lastName, surname }, index) => (
                      <span key={`${firstName}-${lastName}-${surname}-${index}`}>
                        {lastName} {firstName} {surname}
                      </span>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </VerticalDrawer>
      </div>
    </div>
  );
};
